var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureIcon02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-90%",
    y: "-90%",
    width: "280%",
    height: "280%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.713%",
    y1: "0%",
    x2: "77.754%",
    y2: "68.424%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3039",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A94A7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.892%",
    y1: ".428%",
    x2: "24.856%",
    y2: "100%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B404C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333843",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.32,
    fill: "#00BFFB",
    d: "M31.292 84.984l1.313-5.055-14.613 4.415-1.313 5.056z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.203 74.416L.222 46.516l30.541-21.314 23.908 16.277-11.69 10.84-1.706 22-.072.097z",
    fill: "#0270D7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BFFB",
    d: "M103.305 14.443l4.556-4.866-16.287-4.74-4.556 4.867z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02CBB1",
    d: "M56.9 77.244L54.771 92.89 94.416 77.84l2.128-15.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.48,
    fill: "#1D2026",
    filter: "url(#a)",
    d: "M31.778 38.241h40v40h-40z",
    transform: "translate(.222 -2.241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.023 31.352a2.962 2.962 0 0 0-1.296-1.359l-29.464-15.06a2.888 2.888 0 0 0-2.634.001L25.147 30.03a2.972 2.972 0 0 0-1.298 1.361l32.078 16.398 32.096-16.436z",
    fill: "url(#b)",
    fillRule: "nonzero",
    transform: "rotate(31 66.542 55.443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.266 11.908a3.154 3.154 0 0 0-.96.977L23.763 43.707c-.586.974-.605 2.174-.048 3.1l16.423 27.335c.228.379.543.693.917.917l20.09-33.39-17.878-29.76z",
    fill: "#2C3039",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.935 50.59v38.956a3.04 3.04 0 0 0 1.35-.3L70.47 74.263a2.994 2.994 0 0 0 1.67-2.697V35.608a2.98 2.98 0 0 0-.342-1.33L38.935 50.59z",
    fill: "url(#c)",
    transform: "rotate(31 66.143 86.153)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon02);
export default __webpack_public_path__ + "static/media/feature-icon-02.4f1f5f7f7fed2a0d069d4f935455c6b8.svg";
export { ForwardRef as ReactComponent };